/**
 * When services.service_code is null/blank, show SRV + zero-padded id (min width 2), e.g. SRV01, SRV13, SRV904.
 * @param {{ id?: number|string, service_code?: string|null, service_code_display?: string|null }} svc
 */
export function effectiveServiceCode(svc) {
  if (!svc) return '';
  const display = svc.service_code_display != null ? String(svc.service_code_display).trim() : '';
  if (display) return display;
  if (svc.id == null || svc.id === '') return '';
  const raw = svc.service_code != null ? String(svc.service_code).trim() : '';
  if (raw) return raw;
  const id = parseInt(svc.id, 10);
  if (!Number.isFinite(id) || id < 0) return 'SRV';
  return `SRV${String(id).padStart(2, '0')}`;
}
